import { ReactSVG } from 'react-svg';
import classNames from 'classnames';
import { useSortable } from '@dnd-kit/sortable';
import { Button } from '@forma/forma-ui-kit';

import styles from './column-button.module.css';

interface ColumnButtonProps {
  data: { id: string, name: string, width?: string },
  draggable?: boolean,
  checked?: boolean,
  onClick?: () => void,
  onEdit?: () => void,
  onRemove?: () => void,
}

const ColumnButton = ({ data, checked, onClick, onEdit, onRemove }: ColumnButtonProps) => {
  const { attributes, listeners, setNodeRef, transform } = useSortable({ id: data.id, disabled: !checked });

  const style = {
    transform: transform ? `translate3d(${(transform.x ? Math.round(transform.x) : 0)}px, ${(transform.y ? Math.round(transform.y) : 0)}px, 0)` : undefined,
  };

  const viewStyle = checked ? 'primary' : 'secondary';
  const className = checked ? styles.button : classNames(styles.button, styles.secondary);

  return (
    <Button
      viewStyle={viewStyle}
      size="small"
      className={className}
      iconClassName={styles.icons}
      icon={
        <>
          {onEdit && (
            <span
              onClick={e => { e.preventDefault(); e.stopPropagation(); onEdit(); }}
              className={styles.iconEdit}
            >
              <ReactSVG
                src="/icons/edit.svg"
                wrapper="span"
              />
            </span>
          )}
          {onRemove && (
            <span
              className={styles.iconRemove}
              onClick={e => { e.preventDefault(); e.stopPropagation(); onRemove(); }}
            >
              <ReactSVG
                src="/icons/close.svg"
                wrapper="span"
              />
            </span>
          )}
        </>
      }
      onClick={onClick}
      reversed
      {...attributes}
      {...listeners}
      style={style}
      ref={setNodeRef}
    >
      {data.name}
    </Button>
  );
};

export default ColumnButton;
